import { mergeCartAttributes } from "@/cart/cartAttributes";
import type { Cart } from "@/graphql/storefront/generated";

export const REFERRAL_ATTRIBUTE_KEY = "referral_code";

export const getReferralAttribute = (cart?: Cart): string | undefined => {
  const value = cart?.attributes?.find(
    (attribute) => attribute.key === REFERRAL_ATTRIBUTE_KEY,
  )?.value;

  return value ? value.toUpperCase() : undefined;
};

export const mergeReferralAttribute = (
  cart: Cart | undefined,
  code: string,
): Record<string, string> =>
  mergeCartAttributes(cart, { [REFERRAL_ATTRIBUTE_KEY]: code });
